<template lang="pug">
  .searchPanel
    .simpleSearch(v-if="filtro.simplificado", key="simpleSearch")
      form(@submit.prevent="$emit('pesquisar', filtro)")
        el-input.input(
          placeholder=this.isConsultaProcessosAntigos ? 'Informe o nome da gleba' : 'Número do processo, Nome/Razão social do Interessado, CPF/CNPJ do interessado',
          v-model="filtro.campoSimples",
          class="input-with-select"
        )
          el-button.filtro-simplificado(
            slot="append",
            icon="el-icon-search",
            id='botao-filtro-simplificado'
            @click="pesquisar"
          )
    .advancedSearch(v-if="!filtro.simplificado && isConsultaProcessosAntigos")
      form(@submit.prevent="$emit('pesquisar', filtro)")
        .panel
          el-row(:gutter="10")
            el-col(:lg="6", :md="12")
              p.titulo Número do processo:
              el-input.input(
                v-model='filtro.numeroProcesso',
                placeholder='Digite aqui...',
              )
            el-col(:lg="6", :md="12")
              p.titulo Nome/Razão social do interessado:
              el-input.input(
                v-model="filtro.nomeInteressado",
                placeholder='Digite aqui...',
                class="input-with-select"
              )
            el-col(:lg="6", :md="12")
              p.titulo CPF/CNPJ do interessado:
              el-input.input(
                v-model="filtro.cpfCnpjInteressado",
                placeholder='Digite aqui...',
                class="input-with-select"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              )
            el-col(:lg="6", :md="12")
              p.titulo Municípios:
              el-select.full-width(
                multiple
                v-model='filtro.municipio',
                placeholder='Selecione',
                clearable,
                filterable,
                no-match-text="Município não encontrado",
                @clear="filtro.municipio = null"
              )
                el-option(
                  v-for='m in municipios',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
          el-row(:gutter="10")
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Data de cadastro:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Período inicial",
                end-placeholder="Período Final",
                format="dd/MM/yyyy",
                v-model="filtro.dataVencimento"
                name='data',
              )

    .advancedSearch(v-if="!filtro.simplificado && !isConsultaProcessosAntigos")
      form(@submit.prevent="$emit('pesquisar', filtro)")
        .panel
          el-row(:gutter="10")
            el-col(:lg="6", :md="12")
              p.titulo Município da gleba:
              el-select.full-width(
                multiple
                v-model='filtro.idMunicipiosGleba',
                placeholder='Selecione',
                clearable,
                filterable,
                no-match-text="Município não encontrado",
                @clear="filtro.idMunicipiosGleba = null"
              )
                el-option(
                  v-for='m in municipios',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
            el-col(:lg="6", :md="12")
              p.titulo Nome da gleba:
              el-select.full-width(
                multiple
                v-model='filtro.ids',
                placeholder='Selecione',
                clearable,
                filterable,
                no-match-text="Nenhuma gleba encontrada",
                @clear="filtro.municipio = null"
              )
                el-option(
                  v-for='m in nomesGleba',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Data de cadastro:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Período inicial",
                end-placeholder="Período Final",
                format="dd/MM/yyyy",
                v-model="filtro.dataCadastro"
                name='data',
              )
            el-col(:lg="6", :md="12")
              p.titulo Cartório:
              el-input.input(
                v-model="filtro.nomeCartorio",
                class="input-with-select"
              )
          el-row(:gutter="10")
            el-col(:lg="6", :md="12")
              p.titulo Município do cartório:
              el-select.full-width(
                multiple
                v-model='filtro.idMunicipiosCartorio',
                placeholder='Selecione',
                clearable,
                filterable,
                no-match-text="Município não encontrado",
                @clear="filtro.idMunicipiosCartorio = null"
              )
                el-option(
                  v-for='m in municipios',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
            el-col(:lg="6", :md="12")
              p.titulo Matrícula:
              el-input.input(
                type="number"
                v-model="filtro.matricula",
                class="input-with-select",
              )
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Data da matrícula:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Período inicial",
                end-placeholder="Período Final",
                format="dd/MM/yyyy",
                v-model="filtro.dataMatricula"
                name='data',
              )
            <button type="submit" style="display: none;"></button>

    .button-group
      .left-buttons
        el-button.no-padding(
          v-if="showPesquisaAvancadaFiltro"
          type="text",
          @click="changePesquisa"
        ) {{ tituloPesquisa }}
        el-button.no-padding(
          type="text",
          @click="limpar"
        ) Limpar
      .right-buttons
        el-button.btn-filtro(
          v-if="!filtro.simplificado",
          type="primary",
          id='botao-filtro-avancado'
          @click="pesquisar"
        )
          i.el-icon-search
          | &nbsp Pesquisar
  </template>

<script>
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions, mapGetters } from 'vuex'
import PermissaoHelper from '@/screens/analise/PermissaoHelper'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  mixins: [
    PermissaoHelper,
    AppNotificacao
  ],

  props: {
    showPesquisaAvancada: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: filtro.placeholder
    },
    filtro: {
      type: Object,
      required: true
    },
    isConsultaProcessosAntigos: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      caixa: '',
      municipios: [],
      showPesquisaAvancadaFiltro: this.showPesquisaAvancada,
      filtroSearch: {
        pagina: 0,
        municipios: [],
        tipoPesquisa: 'SIMPLIFICADO',
        ordem: 'numeroProcesso'
      },
      nomesGleba: []
    }
  },

  async mounted () {
    this.municipios = await this.findMunicipiosByEstadoAtual()
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    tituloPesquisa () {
      return this.filtro.simplificado ? 'Pesquisa avançada' : 'Pesquisa simplificada'
    }
  },

  methods: {
    ...mapActions({
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      buscarGlebaByMunicipio: 'gleba/buscarGlebaByMunicipio'
    }),
    changePesquisa () {
      this.$emit('changePesquisa')
    },
    pesquisar () {
      this.filtro.pagina = 0
      let filtroFormatado = {
        ...this.filtro,
        dataInicialCadastro: this.filtro.dataCadastro ? this.filtro.dataCadastro[0] : null,
        dataFinalCadastro: this.filtro.dataCadastro ? this.filtro.dataCadastro[1] : null,
        dataInicialMatricula: this.filtro.dataMatricula ? this.filtro.dataMatricula[0] : null,
        dataFinalMatricula: this.filtro.dataMatricula ? this.filtro.dataMatricula[1] : null
      }
      this.$emit('pesquisar', filtroFormatado)
    },

    limpar () {
      this.showPesquisaAvancadaFiltro = true
      this.$emit('limpar')
    }
  },
  watch: {
    async 'filtro.idMunicipiosGleba' (newVal) {
      if (newVal.length) {
        this.nomesGleba = await this.buscarGlebaByMunicipio(newVal)
        const idsValidos = new Set(
          this.nomesGleba.map(g => g.id)
        )
        this.filtro.ids = this.filtro.ids.filter(id => idsValidos.has(id))
      } else {
        this.nomesGleba = []
        this.filtro.ids = []
      }
    },
    'filtro.municipio': {
      handler (newIds) {
        const nomesSelecionados = this.municipios
          .filter(m => newIds.includes(m.id))
          .map(m => m.nome)
        this.filtro.nomeMunicipio = nomesSelecionados
      },
      deep: false
    }
  }
}
</script>

<style scoped lang="scss">

.button-row {
  margin-top: 10px;
  text-align: right;
}

.filtro-simplificado {
  color: #009d64 !important;
  font-size: 16px;
}

.searchPanel {
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .button-group {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 15px;
  }

  .no-padding {
    padding: 0;
  }

  .panel {
    .margin-top {
      margin-top: 10px;
    }

    .titulo {
      font-size: 14px;
    }
  }

  .btn-filtro {
    padding: 8px;
  }
}

.column-checkbox {
  padding-top: 20px;
  padding-bottom: 20px;
}

.full-width {
  width: 100%;
}

.titulo {
  margin: 0;
  padding: 12px 0 8px 0px;
}
</style>



// WEBPACK FOOTER //
// src/screens/bancoDados/components/Filter.vue